import { render, staticRenderFns } from "./yu.vue?vue&type=template&id=1608bc8f&scoped=true&"
import script from "./yu.vue?vue&type=script&lang=js&"
export * from "./yu.vue?vue&type=script&lang=js&"
import style0 from "./yu.vue?vue&type=style&index=0&id=1608bc8f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1608bc8f",
  null
  
)

export default component.exports